import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Briefcase, Layers } from "lucide-react";

type TabType = "Services" | "Variants";

export const videoProductionTabs = [
  {
    label: "Services",
    Icon: Briefcase,
    count: 0,
    value: "Services" as TabType,
  },
  {
    label: "Variants",
    Icon: Layers,
    count: 0,
    value: "Variants" as TabType,
  },
];

export interface DealPreviewEntry {
  variantId: number;
  variantName: string;
  unitPrice: number;
  videoCount: number;
  subtotal: number;
}

export interface DealPreviewDeal {
  name: string;
  variantId: number;
  variantName: string;
  unitPrice: number;
  discount: number;
}

export interface DealPreviewData {
  serviceName: string;
  serviceCode: string;
  entries: DealPreviewEntry[];
  deals: DealPreviewDeal[];
  grossTotal: number;
  discountType: "amount" | "percentage";
  discountValue: number;
  discountAmount: number;
  netAmount: number;
  advance: number;
  pending: number;
  advanceMethod?: string;
  advanceBankName?: string;
  advanceReceiptDocId?: number | null;
}

const initialState = {
  isAddService: false,
  isAddVariant: false,
  videoProductionActiveTab: "Services" as TabType,
  isServiceDetails: false,
  serviceDetailId: null as number | string | null,
  variantDetailId: null as number | string | null,
  startDeal: false,
  showDealPreview: false,
  dealPreviewData: null as DealPreviewData | null,
  pendingDealCount: 0,
  triggerReview: false,
};

const videoProductionFunctionalSlice = createSlice({
  name: "videoProductionFunctional",
  initialState,
  reducers: {
    setIsAddService: (state, action: PayloadAction<boolean>) => {
      state.isAddService = action.payload;
    },
    setIsAddVariant: (state, action: PayloadAction<boolean>) => {
      state.isAddVariant = action.payload;
    },
    setVideoProductionActiveTab: (state, action: PayloadAction<TabType>) => {
      state.videoProductionActiveTab = action.payload;
    },
    setIsServiceDetails: (state, action: PayloadAction<boolean>) => {
      state.isServiceDetails = action.payload;
    },
    setServiceDetailId: (
      state,
      action: PayloadAction<number | string | null>
    ) => {
      state.serviceDetailId = action.payload;
    },
    setVariantDetailId: (
      state,
      action: PayloadAction<number | string | null>
    ) => {
      state.variantDetailId = action.payload;
    },
    setStartDeal: (state, action: PayloadAction<boolean>) => {
      state.startDeal = action.payload;
    },
    setShowDealPreview: (state, action: PayloadAction<boolean>) => {
      state.showDealPreview = action.payload;
    },
    setDealPreviewData: (
      state,
      action: PayloadAction<DealPreviewData | null>
    ) => {
      state.dealPreviewData = action.payload;
    },
    clearDealPreview: (state) => {
      state.showDealPreview = false;
      state.dealPreviewData = null;
      state.pendingDealCount = 0;
      state.triggerReview = false;
    },
    setPendingDealCount: (state, action: PayloadAction<number>) => {
      state.pendingDealCount = action.payload;
    },
    setTriggerReview: (state, action: PayloadAction<boolean>) => {
      state.triggerReview = action.payload;
    },
  },
});

export const {
  setIsAddService,
  setIsAddVariant,
  setVideoProductionActiveTab,
  setIsServiceDetails,
  setServiceDetailId,
  setVariantDetailId,
  setStartDeal,
  setShowDealPreview,
  setDealPreviewData,
  clearDealPreview,
  setPendingDealCount,
  setTriggerReview,
} = videoProductionFunctionalSlice.actions;
export default videoProductionFunctionalSlice.reducer;
